import { classNames } from '@utils/classNames.ts';

export const ValidationError = ({
  isValid,
  errorMessage,
  className,
}: {
  isValid: boolean;
  errorMessage?: string;
  className?: string;
}) => {
  return (
    <span
      className={classNames(
        'block text-orange-600 opacity-0 transition-opacity relative w-full',
        !isValid && 'opacity-100',
        className,
      )}
      data-testid="validation-error"
    >
      {/* This zero-width-space prevents the height from collapsing if there is no error message */}
      &#8203;
      {errorMessage}
    </span>
  );
};
